import React from 'react'
import Header from '../Components/Header'
import useUser from '../hooks/useUser'
import WriteLog from '../Components/Globals/WriteLog'
import Login from '../Components/Login/Login'
import { useNavigate, useParams } from 'react-router-dom'
import Home from '../Components/Home/Home'


//https://tailwindcss.com/docs/top-right-bottom-left

function HomePage(){
                     
    return (      
        <div className='h-screen bg-gradient-to-b from-slate-500'>                
            <div className='h-5/6'>
                <Home/>
            </div>                
            <div className='relative h-1/6'>
                <div className='absolute inset-x-0 bottom-0'>
                    <div className='flex justify-between items-center mt-24 border-t-2 border-gray-300 bg-slate-600 align-bottom'>
                        <div className='text-sm text-white'>
                                Customer Portal
                        </div>
                        <div className='flex justify-start items-center space-x-2'>
                            <div className='rounded-full'>
                                <img className='rounded-full w-7 h-7' src="/100.png" />
                            </div>
                            <div className='italic text-sm text-white'>
                                Powered by Softrend Systems Inc.
                            </div>                    
                        </div>                
                    </div> 
                </div>
            </div>                                   
        </div>          
    )
}

export default HomePage